


























import Vue from "vue";
import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

export default Vue.extend({
  name: "MaintenanceMode",

  data() {
    return {
      waiting: false,
      waitTime: 30000
    };
  },

  methods: {
    handleRetryButtonClick() {
      this.$store.dispatch(VUEX_ROOT_ACTION_NAMES.CHECK_APP_HASH);

      this.waiting = true;

      window.setTimeout(() => {
        this.waiting = false;
      }, this.waitTime);
    }
  },

  computed: {
    maintenanceMessage() {
      return this.$store.state.maintenanceMode?.message || "";
    }
  }
});
